<template>
  <v-container fluid>
    <Grid
      title="Tokens"
      :headers="headers"
      :hasBtnAdd="false"
      :items="tokens"
      @destroy="destroyToken"
      @atualiza="getTokens"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Grid from '@/components/shared/Grid';

export default {
  name: 'Tokens',
  data: () => ({
    headers: [
      {
        text: 'Pessoa',
        align: 'start',
        value: 'client_key.nome',
      },
      { text: 'Licença', value: 'licenca.titulo' },
      { text: 'App', value: 'app_key.descricao' },
      { text: 'Dispositivo', value: 'dispositivo' },
      { text: 'Criado em', value: 'createdAt' },
      { text: 'Atualizado em', value: 'updatedAt' },
      { text: 'Expira em', value: 'expiresIn' },
      { text: 'Ações', value: 'actions', sortable: false },
    ],
  }),
  components: {
    Grid,
  },
  computed: {
    ...mapGetters(['tokens'])
  },
  methods: {
    ...mapActions(['fetchTokens', 'deleteToken']),
    getTokens() {
      this.fetchTokens({ limit: 999 });
    },
    destroyToken(token) {
      if (confirm(`Tem certeza que deseja excluir o token: ${token.client_key.nome}@${token.app_key.descricao}?`)) {
        this.deleteToken(token._id);
      }
    }
  },
  created() {
    this.getTokens();
  }
}
</script>

<style>

</style>